import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../../base-dialog';
import { Address } from '../../../forms/address-form/address-form.component';

@Component({
  selector: 'mandae-address-form-dialog',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent extends BaseDialog<AddressFormComponent> implements OnInit {

  public address: Address = null;

  constructor(@Inject(MAT_DIALOG_DATA) private data, dialogRef: MatDialogRef<AddressFormComponent>) {
    super(dialogRef);
  }

  ngOnInit() {
    if (this.data && this.data.address) {
      this.address = {
        number: this.data.address.numero,
        street: this.data.address.logradouro,
        district: this.data.address.bairro,
        city: this.data.address.cidade,
        state: this.data.address.uf,
        postalCode: this.data.address.cep,
        complement: this.data.address.complemento,
        observation: this.data.address.referencia,
      };
    }
  }

}
